<template>
  <transition name="fade">
    <div class="ai-dialog" v-if="visible" @click.stop>
      <div class="ai-header">
        <div class="ai-title">易小创</div>
        <div class="close-btn" @click.stop="close"><i class="el-icon-close"></i></div>
      </div>
      <div class="ai-body">
        <iframe class="ai-window" :src="iframeSrc"></iframe>
      </div>
    </div>
  </transition>
</template>

<script>
import { getUUid } from '@/utils';

export default {
  data() {
    return {
      visible: false,
      iframeSrc: ''
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      let sessionId = this.$localCache.get('ai_session_id');
      if (!sessionId) {
        sessionId = getUUid();
        this.$localCache.set('ai_session_id', sessionId);
      }
      this.iframeSrc = `https://chatbox.longstron.com?sessionId=${sessionId}`;
    },
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    }
  },
};
</script>

<style lang="less" scoped>
.ai-dialog {
  width: 452px;
  height: 732px;
  background: #FFFFFF;
  box-shadow: -7px 0px 20px 0px rgba(0,0,0,0.06);
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 50%;
  left: -20px;
  transform: translate(-100%, -50%);
  transition: all 0.3s ease;

  &.fade-enter,
  &.fade-leave-to {
    transform: translate(calc(-100% + 25px), -50%);
    opacity: 0;
  }

  .ai-header {
    height: 40px;
    padding: 0 20px;
    background-color: #FF8201;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .ai-title {
      color: #fff;
      font-family: @font-medium;
      line-height: 40px;
    }
    .close-btn {
      font-size: 22px;
      // color: #666;
      cursor: pointer;
      &:hover {
        color: #fff;
      }
    }
  }
  .ai-body {
    flex: 1;
    padding: 0 6px 6px;
    .ai-window {
      width: 100%;
      height: 100%;
      border: none;
    }
  }
}
</style>
